import React, { useEffect, useState } from 'react';

import { ContentWrapper } from './distribution.styled';

export const Distribution = () => {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    const getHtml = async () => {
      await fetch(`${window.config.assets_path}/distribution.html`, {
        method: 'GET'
      })
        .then(async (r) => {
          const html = await r.text();
          setHtmlContent(html);
        })
        .catch((er) => console.error(er));
    };
    getHtml();
  }, []);

  return <ContentWrapper dangerouslySetInnerHTML={{ __html: htmlContent }}></ContentWrapper>;
};
